import { render, staticRenderFns } from "./SchoolEventsTimetable.vue?vue&type=template&id=84e5a58a"
import script from "./SchoolEventsTimetable.vue?vue&type=script&lang=js"
export * from "./SchoolEventsTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports